import QuestionsGenerationAction from './QuestionsGenerationAction';
import QuestionsRenderedAction from './QuestionsRenderedAction';
import QuestionGenerationBatchSubmissionAction from './QuestionsSubmittedAction';
import {
  QuestionGenerationInputData,
  QUESTION_ACTION_TAGS,
} from './BaseQuestionGeneration';

// Create singleton instances
const statAction = new QuestionsGenerationAction();
const renderTimeAction = new QuestionsRenderedAction();
const batchSubmissionAction = new QuestionGenerationBatchSubmissionAction();

/**
 * Track question generation statistics
 */
export function trackQuestionGeneration(
  input: QuestionGenerationInputData & {
    requestedCount: number;
    generatedCount: number;
    failedCount: number;
    generationTime: number;
  },
) {
  statAction.sendAction(input);
}

/**
 * Track time to render a generated question
 */
export function trackQuestionsRendered(
  input: QuestionGenerationInputData & { questionId?: string },
) {
  renderTimeAction.sendAction(input);
}

/**
 * Track batch submission statistics
 */
export function trackQuestionsSubmitted(
  input: QuestionGenerationInputData & {
    requestedCount: number;
    submittedCount: number;
    deletedCount: number;
  },
) {
  batchSubmissionAction.sendAction(input);
}

// Re-export tags for convenience
export { QUESTION_ACTION_TAGS };
